import { useState } from 'react'
import { X } from 'lucide-react'

interface TagInputProps {
  value: string[]
  onChange: (tags: string[]) => void
  placeholder?: string
  className?: string
}

export function TagInput({ value, onChange, placeholder = 'Ajouter...', className = '' }: TagInputProps) {
  const [input, setInput] = useState('')

  const addTag = () => {
    const trimmed = input.trim()
    if (trimmed && !value.includes(trimmed)) {
      onChange([...value, trimmed])
      setInput('')
    }
  }

  const removeTag = (index: number) => {
    onChange(value.filter((_, i) => i !== index))
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      addTag()
    }
    if (e.key === 'Backspace' && input === '' && value.length > 0) {
      removeTag(value.length - 1)
    }
  }

  return (
    <div className={`flex flex-wrap items-center gap-1.5 px-3 py-2 border border-[#E2E4ED] rounded-lg bg-white focus-within:border-[#6366F1] focus-within:ring-1 focus-within:ring-[#6366F1]/20 transition-colors ${className}`}>
      {value.map((tag, i) => (
        <span key={i} className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#6366F1]/10 text-[#6366F1] text-sm rounded-md">
          {tag}
          <button type="button" onClick={() => removeTag(i)} className="hover:text-red-500 transition-colors">
            <X size={14} />
          </button>
        </span>
      ))}
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={addTag}
        placeholder={value.length === 0 ? placeholder : ''}
        className="flex-1 min-w-[120px] outline-none text-sm text-[#1B2559] placeholder:text-[#8B8FA7]"
      />
    </div>
  )
}
